import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  FaBars,
  FaTimes,
  FaSignInAlt,
  FaSignOutAlt,
} from "react-icons/fa";
import { signOut } from "firebase/auth";
import { auth } from "../../Firebase_Config/firebaseConfig";
import logo from "../../Assets/Company_Logo.png";
import "./navbar2.css";

const UserNav = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(true);

  const lastScrollY = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll behavior
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 20);

      if (!menuOpen) {
        if (y > lastScrollY.current && y > 80) {
          setVisible(false);
        } else {
          setVisible(true);
        }
      }
      lastScrollY.current = y;
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [menuOpen]);

  // Disable scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSignOut = () => {
    signOut(auth).then(() => {
      localStorage.clear();
      props.setAuthenticated(false);
      props.setIsAdmin(false);
      navigate("/Login");
    });
  };

  const goToSection = (id) => {
    navigate("/");
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  return (
    <>
      <Helmet>
        <title>Valsco Technology</title>
      </Helmet>

      {/* ================= NAVBAR ================= */}
      <nav
        className={`new-navbar ${
          visible ? "visible" : "hidden-nav"
        } ${scrolled ? "scrolled" : ""}`}
      >
        {/* LOGO */}
        <Link to="/" className="brand" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="Valsco Logo" className="brand-logo" />
          <span className="brand-name">Valsco Technology</span>
        </Link>

        {/* CENTER LINKS */}
        <div className="nav-center">
          <span className="nav-link" onClick={() => goToSection("products")}>
            Products
          </span>

          <span className="nav-link" onClick={() => goToSection("about")}>
            About Us
          </span>

          <NavLink to="/BlogHome" className="nav-link">
            Blogs
          </NavLink>

          <NavLink to="/courses" className="nav-link">
            Courses
          </NavLink>

          <NavLink to="/careers" className="nav-link">
            Careers
          </NavLink>

          <NavLink to="/services" className="nav-link">
            Services
          </NavLink>

          {/* <NavLink to="/" className="nav-link">
            Home
          </NavLink> */}

          {/* <NavLink to="/BlogHome" className="nav-link">
            Read Blogs
          </NavLink> */}
        </div>

        {/* RIGHT SIDE */}
        <div className="nav-right">
          {/* ADMIN BUTTON */}
          {props.authenticated && props.isAdmin && (
            <button
              className="admin-btn"
              onClick={() => navigate("/AdminPortal")}
            >
              Admin Panel
            </button>
          )}

          {/* LOGIN / LOGOUT */}
          {props.authenticated ? (
            <button className="contact-btn" onClick={handleSignOut}>
              <FaSignOutAlt /> Logout
            </button>
          ) : (
            <Link to="/Login">
              <button className="contact-btn">
                <FaSignInAlt /> Login
              </button>
            </Link>
          )}

          {/* MOBILE MENU BUTTON */}
          <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
            <FaBars />
          </button>
        </div>
      </nav>

      {/* ================= MOBILE MENU ================= */}
      {menuOpen && (
        <div className="mobile-menu open">
          <div className="mobile-menu-inner">
            {/* CLOSE BUTTON */}
            <button
              className="mobile-close"
              onClick={() => setMenuOpen(false)}
            >
              <FaTimes />
            </button>

            {/* LINKS */}
            <ul className="mobile-links">
              <li>
                <span
                  onClick={() => {
                    goToSection("products");
                    setMenuOpen(false);
                  }}
                >
                  Products
                </span>
              </li>

              <li>
                <span
                  onClick={() => {
                    goToSection("about");
                    setMenuOpen(false);
                  }}
                >
                  About Us
                </span>
              </li>

              <li>
                <NavLink to="/BlogHome" onClick={() => setMenuOpen(false)}>
                  Blogs
                </NavLink>
              </li>

              <li>
                <NavLink to="/courses" onClick={() => setMenuOpen(false)}>
                  Courses
                </NavLink>
              </li>

              <li>
                <NavLink to="/careers" onClick={() => setMenuOpen(false)}>
                  Careers
                </NavLink>
              </li>

              <li>
                <NavLink to="/services" onClick={() => setMenuOpen(false)}>
                  Services
                </NavLink>
              </li>

              {/* <li>
                <NavLink to="/" onClick={() => setMenuOpen(false)}>
                  Home
                </NavLink>
              </li> */}

              {/* <li>
                <NavLink to="/BlogHome" onClick={() => setMenuOpen(false)}>
                  Read Blogs
                </NavLink>
              </li> */}

              {/* USER */}
              {props.authenticated && !props.isAdmin && (
                <li>
                  <NavLink
                    to="/CreateBlog"
                    onClick={() => setMenuOpen(false)}
                  >
                    Create Blog
                  </NavLink>
                </li>
              )}

              {/* ADMIN */}
              {props.authenticated && props.isAdmin && (
                <li>
                  <NavLink to="/AdminPortal" onClick={() => setMenuOpen(false)}>
                    Admin Panel
                  </NavLink>
                </li>
              )}
            </ul>

            {/* BUTTON */}
            {props.authenticated ? (
              <button className="mobile-contact" onClick={handleSignOut}>
                <FaSignOutAlt /> Logout
              </button>
            ) : (
              <button
                className="mobile-contact"
                onClick={() => {
                  setMenuOpen(false);
                  navigate("/Login");
                }}
              >
                <FaSignInAlt /> Login
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default UserNav;